import { Plus, MagnifyingGlass } from '@phosphor-icons/react';
import { Button, Flex, Input } from 'antd';
import { IconSizes } from '@utility/constants/style-contants';

/** Actions aligned to the right of Users / Open Invitations sub-tabs. */
export function SettingsUsersToolbar({ search, onSearchChange, onAddUser }) {
  return (
    <Flex align="center" gap={8} wrap="nowrap">
      <Button type="primary" icon={<Plus size={16} />} onClick={onAddUser}>
        User
      </Button>
      <Input
        placeholder="Search Users"
        value={search ?? ''}
        onChange={e => onSearchChange(e.target.value)}
        allowClear
        prefix={<MagnifyingGlass size={IconSizes.small} />}
        style={{ width: 200 }}
      />
    </Flex>
  );
}
